<!--footer -->
<footer class="main-footer fl-wrap">
    <!-- footer-header-->
    <div class="footer-header fl-wrap grad ient-dark">
        <div class="container">
            <div class="row">
                <div class="col-md-5">
                    <div class="subscribe-header">
                        <h3>Subscribe For a <span>Newsletter</span></h3>
                        <p>Whant to be notified about new locations ? Just sign up.</p>
                    </div>
                </div>
                <div class="col-md-7">
                    <div class="subscribe-widget">
                        <div class="subcribe-form">
                            <form id="subscribe">
                                <input class="enteremail fl-wrap" name="email" id="subscribe-email" placeholder="Enter Your Email" type="text">
                                <button type="submit" id="subscribe-button" class="subscribe-button"><i class="fal fa-envelope"></i></button>
                                <label for="subscribe-email" class="subscribe-message"></label>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- footer-header end-->
    <!--footer-inner-->
    <div class="footer-inner fl-wrap">
        <div class="container">
            <div class="row">
                <!-- footer-widget-->
                <div class="col-md-4">
                    <div class="footer-widget fl-wrap">
                        <div class="footer-logo">
                            <a href="https://businessinmaharashtra.com" target="_blank"><img src="../../assets/images/bim.png" alt="Business in Maharashtra"></a><br> 
                            <div class="clearfix mb-2"></div>
                        </div>
                        <div class="footer-contacts-widget fl-wrap">
                            <p> Advertising and promotion are essential components of a successful business. Their effects include brand establishment, growth within your target market segment, the discovery of new secondary markets. </p>
                            <ul class="footer-contacts fl-wrap no-list-style">
                                <li> <span><i class="fal fa-map-marker"></i> Address :</span><a routerLinkActive="active" routerLink="contact">Pune -Maharashtra</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <!-- footer-widget end-->
                <!-- footer-widget-->
                <div class="col-md-4">
                    <div class="footer-widget fl-wrap">
                        <h3>ABOUT US</h3>
                        <div class="footer-contacts-widget fl-wrap">
                            <p>
                                <a class="white_color" routerLinkActive="active" routerLink="about" title="About Us">About Us</a> <br>
                                <span *ngIf="!userIsAuthenticated"><a class="white_color" routerLinkActive="active" routerLink="register" title="Register">Register</a> <br></span>
                                <a class="white_color" routerLinkActive="active" routerLink="contact" title="Contact Us">Contact Us</a> <br>
                                <a class="white_color" routerLinkActive="active" routerLink="advertising-plan" title="Business Plan">Business Plan</a> <br>
                                <a class="white_color" routerLinkActive="active" routerLink="site-map" title="Site Map">Site Map</a> <br>
                            </p>
                            <br>
                        </div>
                        <h3>BUYERS & SELLERS</h3>
                        <div class="footer-contacts-widget fl-wrap">
                            <p>
                                <a class="white_color" routerLinkActive="active" routerLink="advertising-plan" title="Advertise with BIM">Advertise with BIM</a> <br>
                            </p>
                            <ul class="footer-contacts fl-wrap no-list-style">
                                <li><span><i class="fal fa-envelope"></i> Mail :</span><a href="mailto:support@businessinmaharashtra.com" target="_blank">support&#64;businessinmaharashtra.com</a> </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <!-- footer-widget end-->
                <!-- footer-widget  -->
                <div class="col-md-4">
                    <div class="footer-widget fl-wrap ">
                        <h3>OUR SERVICES</h3>
                        <div class="footer-contacts-widget fl-wrap">
                            <p>
                                <a class="white_color" routerLinkActive="active" routerLink="terms-and-conditions" title="Terms and condition">Terms and condition</a> <br>
                                <a class="white_color" routerLinkActive="active" routerLink="privacy-policy" title="Privacy Policy">Privacy Policy</a> <br> 
                                <a class="white_color" routerLinkActive="active" routerLink="return-policy" title="Return Policy">Return Policy</a><br>
                                <a class="white_color" routerLinkActive="active" routerLink="refund-and-cancellation" title="Refund and Cancellation">Refund and Cancellation</a><br>
                                <a class="white_color" routerLinkActive="active" routerLink="shipping-policy" title="Shipping and Delivery">Shipping and Delivery Policy</a> <br>
                                <a class="white_color hide" routerLinkActive="active" routerLink="news" title="Blog">Blog</a>
                            </p>
                        </div>
                        <div class="footer-social">
                            <h3>FIND US ON</h3>
                            <ul class="no-list-style">
                                <li><a href="https://www.facebook.com/bim.directory" target="_blank"><i class="fab fa-facebook-f"></i></a></li>
                                <li><a href="https://twitter.com/businessMaharas" target="_blank"><i class="fab fa-twitter"></i></a></li>
                                <li><a href="https://in.linkedin.com/in/businessinmaharashtra" target="_blank"><i class="fab fa-linkedin"></i></a></li>
                                <li><a href="https://www.instagram.com/businessinmaharashtra_india/" target="_blank"><i class="fab fa-instagram"></i></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <!-- footer-widget end-->
            </div>
        </div>
        <!-- footer bg-->
        <div class="footer-bg" data-ran="4"></div>
        <div class="footer-wave">
            <svg viewbox="0 0 100 25">
                    <path fill="#fff" d="M0 30 V12 Q30 17 55 12 T100 11 V30z" />
                </svg>
        </div>
        <!-- footer bg  end-->
    </div>
    <!--footer-inner end -->
    <!--sub-footer-->
    <div class="sub-footer  fl-wrap">
        <div class="container">
            <div class="copyright">&#169; {{ currentYear }}, Business in Maharashtra. All rights reserved.</div>
            <div class="lang-wrap">
                <div class="show-lang">
                    <span><i class="fal fa-globe-europe"></i><strong>Country</strong></span>
                    <i class="fa fa-caret-down arrlan"></i>
                </div>
                <ul class="lang-tooltip lang-action no-list-style">
                    <li><a href="#" class="current-lan" data-lantext="En">India</a></li>
                </ul>
            </div>
            <div class="subfooter-nav">
                <ul class="no-list-style">
                    <li><a routerLinkActive="active" routerLink="contact" href="#" title="Contact us">Contact us</a></li>
                    <li><a routerLinkActive="active" routerLink="terms-and-conditions" href="#" title="Terms and condition">Terms and condition</a></li>
                    <li><a routerLinkActive="active" routerLink="privacy-policy" href="#" title="Privacy Policy">Privacy Policy</a></li>
                    <li><a routerLinkActive="active" routerLink="return-policy" title="Return Policy">Return Policy</a> </li>
                    <li><a routerLinkActive="active" routerLink="refund-and-cancellation" title="Refund and Cancellation">Refund and Cancellation</a> </li>
                    <li><a routerLinkActive="active" routerLink="shipping-policy" href="#" title="Shipping and Delivery">Shipping and Delivery Policy</a> </li>
                    <li class="hide"><a routerLinkActive="active" routerLink="news" href="#" title="Blog">Blog</a></li>
                </ul>
            </div>
        </div>
    </div>
    <!--sub-footer end -->
</footer>
<!--footer end -->